import { Controller } from 'stimulus';

export default class extends Controller {
  #onUpdate = null;
  static values = { collectionName: String };

  connect() {
    this.baseUrl = this.element.getAttribute('href');
    this.#onUpdate = this.#updateUrl.bind(this);
    this.element.addEventListener('batch-action-bar:update', this.#onUpdate);
  }

  disconnect() {
    this.element.removeEventListener('batch-action-bar:update', this.#onUpdate);
  }

  #updateUrl(event) {
    const url = new URL(this.baseUrl, window.location.origin);

    Array.from(event.detail.selected).forEach((element, index) => {
      url.searchParams.set(this.#paramName(index, 'item_type'), element.resource_type);
      url.searchParams.set(this.#paramName(index, 'item_id'), element.resource_id);
    });

    this.element.setAttribute('href', url.toString());
  }

  #paramName(index, attribute) {
    return `${this.collectionNameValue}[${index}][${attribute}]`;
  }
}
